module.exports = __webpack_public_path__ + "static/media/epay.876d62ff.png";